import { h, Fragment } from 'preact';
import { useKitProduct } from './kit/product-context';
import { useProduct } from './product-context';
import ProductGallery from './product-gallery';
import ProductInfo from './product-info';
import ProductSizeGuide from './product-size-guide';
import './product.css';

const Product = () => {
  const { allProducts, isKit } = useProduct();
  const kit = useKitProduct();

  if (!allProducts) return;
  if (isKit && !kit) return;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-desktopPDP bg-white relative">
      <ProductGallery />
      <ProductInfo />
      <ProductSizeGuide />
    </div>
  );
};

export default Product;
